import React, { useState } from 'react';
import BaseFilterButton, { BaseFilterButtonProps } from './BaseFilterButton';
import { Popover, PopoverContent, PopoverTrigger } from '@/Components/shadcn';

export interface BaseFilterProps extends Pick<BaseFilterButtonProps, 'label' | 'activeFilterCount'> {
    children: React.JSX.Element;
}

function BaseFilter({ label, activeFilterCount, children }: BaseFilterProps): React.JSX.Element {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <BaseFilterButton open={open} label={label} activeFilterCount={activeFilterCount} />
            </PopoverTrigger>
            <PopoverContent
                data-cy="AdvancedFilterPanel"
                side="bottom"
                align="start"
                className="flex w-full min-w-80 gap-0 p-0"
            >
                {children}
            </PopoverContent>
        </Popover>
    );
}

export default BaseFilter;
